
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { brandColors as colors, usePalette } from "@/lib/palette";
import { fonts } from "@/lib/fonts";
import { fadeUp, stagger } from "@/lib/animations";

export default function KindWordsSection() {
  const theme = usePalette();
  const words = [
    {
      quote:
        "Chelsea's energy is absolutely contagious. She makes sewing feel accessible and FUN.",
      name: "Sarah M.",
      tag: "Fellow Sewist",
    },
    {
      quote:
        "I started sewing because of her TikToks. Now I have a whole closet of handmade clothes!",
      name: "Jamie L.",
      tag: "Community Member",
    },
    {
      quote:
        "The best creator content out there. Real, relatable, and always makes my day better.",
      name: "Priya K.",
      tag: "YouTube Subscriber",
    },
  ];

  return (
    <section
      className="py-24 px-6 relative"
      style={{ backgroundColor: colors.cream }}
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-80px" }}
          variants={stagger}
          className="text-center mb-16"
        >
          <motion.p
            variants={fadeUp}
            custom={0}
            className="text-xs tracking-[0.2em] uppercase mb-3"
            style={{
              fontFamily: fonts.body,
              fontWeight: 700,
              color: theme.accent,
            }}
          >
            Kind Words
          </motion.p>
          <motion.h2
            variants={fadeUp}
            custom={1}
            className="text-4xl lg:text-5xl"
            style={{
              fontFamily: fonts.logo,
              fontWeight: 400,
              color: colors.navy,
            }}
          >
            From the{" "}
            <span style={{ fontFamily: fonts.heading, color: theme.warm }}>
              Community
            </span>
          </motion.h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-40px" }}
          variants={stagger}
          className="grid md:grid-cols-3 gap-8"
        >
          {words.map((w, i) => (
            <motion.div
              key={w.name}
              variants={fadeUp}
              custom={i}
              className="rounded-2xl p-8 relative cursor-default"
              style={{ backgroundColor: theme.accentSoft }}
            >
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star
                    key={j}
                    size={14}
                    fill={theme.warm}
                    style={{ color: theme.warm }}
                  />
                ))}
              </div>
              <p
                className="mb-6 leading-relaxed"
                style={{
                  fontFamily: fonts.body,
                  fontWeight: 500,
                  color: `${colors.navy}bb`,
                  letterSpacing: "0.03em",
                }}
              >
                &ldquo;{w.quote}&rdquo;
              </p>
              <div>
                <p
                  className="text-sm"
                  style={{
                    fontFamily: fonts.body,
                    fontWeight: 700,
                    color: colors.navy,
                  }}
                >
                  {w.name}
                </p>
                <p
                  className="text-xs"
                  style={{
                    fontFamily: fonts.body,
                    fontWeight: 500,
                    color: theme.accent,
                  }}
                >
                  {w.tag}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
